import { Component, OnInit } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { NbIconLibraries } from '@nebular/theme';
import { EventTypes, PublicEventsService } from 'angular-auth-oidc-client';
import { filter } from 'rxjs/operators';
import { AuthService } from './core/authencation/auth.service';
import { LoaderService } from './core/services/loadder/loadder.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent implements OnInit {

  title = 'app';

  constructor(private iconLibraries: NbIconLibraries, private router: Router,
    private readonly eventService: PublicEventsService, public authService: AuthService, 
    private location: Location, 
    private loaderService: LoaderService
  ) {
    this.iconLibraries.registerFontPack('font-awesome', { iconClassPrefix: 'fa', packClass: 'fa' });
    this.iconLibraries.setDefaultPack('font-awesome'); // <---- set as default
    this.eventService
      .registerForEvents()
      .pipe(filter((notification) => notification.type === EventTypes.ConfigLoaded))
      .subscribe((config) => console.log('ConfigLoaded', config));
  }

  ngOnInit(): void {
    this.authService
      .checkAuth()
      .subscribe((isAuthenticated) => {
        var path = this.location.path();
        if (!isAuthenticated) {          
          if ('/login' !== path) {
            this.write('redirect', path);
            this.router.navigate(['/login']);
          }
        }
        if (isAuthenticated) {
          if (this.authService.userData) {
            this.navigateToStoredEndpoint();
          }
        }
      });
    this.showLoaderOnRouterNavigate();
  }

  showLoaderOnRouterNavigate() {
    this.router.events
      .subscribe(event => {
        if (event instanceof NavigationStart) {
          this.loaderService.show();
        }
        if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
          this.loaderService.hide();
        }
      });
  }
  private navigateToStoredEndpoint() {
    const path = this.read('redirect');
    if (path) {
      this.write('redirect', '');
      if (path.toString().includes('/unauthorized')) {
        this.router.navigateByUrl('/');
      } else {
        this.router.navigateByUrl(path);
      }
    }
  }

  private read(key: string): any {
    const data = localStorage.getItem(key);
    if (data != null) {
      return JSON.parse(data);
    }

    return;
  }

  private write(key: string, value: any): void {
    localStorage.setItem(key, JSON.stringify(value));
  }
}
